import React from "react";
import { Button } from "react-bootstrap";

const SelectQuestTableRow = ({
  quest,
  type,
  isChecked,
  toggleQuestCheck,
  removeQuest,
}) => {
  return (
    <tr>
      <td style={{ width: "60px", verticalAlign: "middle", padding: "12px 16px", paddingLeft: "30px" }}>
        {type === "select" ? (
          <div>
            <input
              className="form-check-input m-0"
              type="checkbox"
              checked={isChecked || false}
              onChange={() => toggleQuestCheck(quest.id)}
              id={`checkbox-${quest.id}`}
              style={{ width: "1.2rem", height: "1.2rem" }}
            />
          </div>
        ) : (
          <Button
            variant="danger"
            size="sm"
            onClick={() => removeQuest(quest.id)}
            className="remove-student-btn"
          >
            <i className="bi bi-trash"></i>
          </Button>
        )}
      </td>

      <td className="custom-name" style={{ verticalAlign: "middle", padding: "12px 16px" }}>
        <div className="d-flex align-items-center gap-3">
          <img
            src={quest.thumbnail_url}
            alt=""
            style={{
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              objectFit: "cover",
            }}
          />
          <span>{quest.title}</span>
        </div>
      </td>
    </tr>
  );
};

export default SelectQuestTableRow;
